import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";
import MyTable from "../../../components/MyTable";
import { resetLoansSort, searchEmployeeLoans, setLoancancelResult, setLoanDetails, setLoansSort } from "../../../store/slices/documents";
import { EMPLOYEE_LOANS_ONE, EMPLOYEE_LOANS_THREE, EMPLOYEE_LOANS_TWO } from "../../../constants/signalRequestConsts";
import { useEffect, useState } from "react";
import { Box, Button, Card, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography, useTheme } from "@mui/material";
import MySnackbar from "../../../components/MySnackbar";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getEmployeeLoanDetails, setEmployeeLoanCancel, setEmployeeLoanHasNote } from "../../../api/signalApi";
import { getDatestring } from "../../../utils/date";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import AttachFileIcon from '@mui/icons-material/AttachFile';

import "./index.css";
import { DocumentsComponent } from "../../../components/DocumentsComponent";
interface TableLoansProps {
    numberOfCards?: number;
    changeViewOptionHidden?: boolean;
    startDate?: Date;
    endDate?: Date;
    requestId: (typeof EMPLOYEE_LOANS_ONE | typeof EMPLOYEE_LOANS_TWO |  typeof EMPLOYEE_LOANS_THREE)

    status?: 0 | 1;

    hiddenBottomPaginator?: boolean;
    hiddenFilterOptions?: boolean;
    refreshKey?: number;
}

const TableLoans = ({requestId, hiddenFilterOptions, refreshKey, ...props}: TableLoansProps) => {

    const theme = useTheme();
    const loans = useSelector((state: RootState) => state.documents[requestId]);
    const {paymentDetails, cancelSuccess, cancelMsg, success} = useSelector((state: RootState) => state.documents.loans);
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch<AppDispatch>();
    const [loanToObservate, setLoanToObservate] = useState<any>();
    const [observationResult, setObservationResult] = useState<{success: boolean, msg: string} | null>(null);
    const [startDate, setStartDate] = useState<Date | null>(props.startDate || null);
    const [endDate, setEndDate] = useState<Date | null>(props.endDate || null);
    const [pageQuantity, setPageQuantity] = useState<number>(10);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);
    const [loanToCancel, setLoanToCancel] = useState<any>(null);
    const [loanCancelResult, setLoanCancelResult] = useState<any>(null);
    const [couponForFileViewing, setCouponForFileViewing] = useState<any | null>(null);

    const employeeLoansTableHeadRows = [
        {
            label: "Préstamo N°",
            rowKeyName: "CodPrestamoPersonal",
            allowOrderAction: true,
        }, {
            label: "Moneda",
            rowKeyName: "DescripcionMoneda",
            allowOrderAction: true,
        }, {
            label: "Fecha",
            rowKeyName: "Fecha",
            allowOrderAction: true,
        }, {
            label: "Monto Solicitado",
            rowKeyName: "MontoOtorgado",
            allowOrderAction: true,
        }, {
            label: "Monto Amortizado",
            rowKeyName: "MontoAmortizado",
            allowOrderAction: true,
        }, {
            label: "Estado",
            rowKeyName: "Estado",
            allowOrderAction: true,
        }, {
            label: "Observaciones",
            rowKeyName: "Observaciones",
            allowOrderAction: true,
        },
    ];

    useEffect(() => {
        if (!success || requestId !== EMPLOYEE_LOANS_TWO) {
            return;
        }
        findLoans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [success]);

    useEffect(() => {
        if (cancelSuccess === null || cancelMsg === null || !loading) {
            return;
        }
        setLoanCancelResult({success: cancelSuccess, msg: cancelMsg});
        setLoanToCancel(null);
        setLoading(false)
        findLoans();
        dispatch(setLoancancelResult({success: null, msg: null}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cancelSuccess]);

    useEffect(() => {
        if (!companyselected || !connectionId) {
            return;
        }
        findLoans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected, connectionId, pageNumber, pageQuantity, refreshKey]);

    useEffect(() => {
        if (!companyselected || !connectionId) {
            return;
        }
        dispatch(setLoanDetails([]));
        if (!loanToObservate) {
            return;
        }
        getEmployeeLoanDetails(loanToObservate.NroPrestamoPersonal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [companyselected, connectionId, loanToObservate]);

    const findLoans = () => {
        dispatch(resetLoansSort(requestId));
        dispatch(searchEmployeeLoans((props.status || 0), requestId, pageQuantity, pageNumber));
    }
    
    const LoanOptions = ({row}: any) => {
        return (
            <Grid container direction="row" minWidth={"5rem"} justifyContent='flex-end' pr='.5rem'>
                <Grid item maxWidth="1.5rem">
                    <IconButton
                        aria-label="ver adjuntos"
                        disabled={!row.TieneNota}
                        onClick={() =>{
                            setCouponForFileViewing(row)
                        }}
                        style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            padding: ".25rem",

                            lineHeight: "1.25rem", 
                        }}
                    >
                        <AttachFileIcon
                            color={row.TieneNota 
                                ? "primary" 
                                : "disabled"
                            } 
                        />
                    </IconButton>
                </Grid>
                <Grid item maxWidth="1.5rem">
                    <IconButton
                        onClick={() => setLoanToObservate(row)}
                        aria-label="Ver documento"
                        style={{
                            color: theme.s10palette.S10Blueblue700,
                            width: "1.5rem",
                            height: "1.5rem",
                            padding: ".25rem",
                        }}
                    >
                        <VisibilityIcon />
                    </IconButton >
                </Grid>
                {(row.Estado === "Por Aprobar" && Number(row.MontoOtorgado)  === 0) &&
                    <Grid item maxWidth="1.5rem">
                        <IconButton
                            disabled={loading}
                            aria-label="Cancelar cupón"
                            onClick={!loading ? () => setLoanToCancel(row as any) : undefined }
                            style={{
                                width: "1.5rem",
                                height: "1.5rem",
                                padding: ".25rem"
                            }}
                        >
                            {loading 
                                ? <CircularProgress color="primary" size="1rem" />
                                : <DeleteIcon color="error" />
                            }
                        </IconButton >
                    </Grid>
                }
            </Grid>
        )
    }

    return (
        <>
        <MyTable
            key="tab-4"
            hiddenFilterOptions={hiddenFilterOptions}
            // calculateLimitDate={true}
            // dateFilterField={'Fecha'}
            tableHeadRows={employeeLoansTableHeadRows}
            tableRows={loans.loans}
            totalItems={loans.totalItems}
            totalPages={loans.totalItems / pageQuantity}
            onChangePageNumber={(value) => setPageNumber(value)}
            onChangeItemsPerPage={(value) => setPageQuantity(value)}
            setOrderedData={(sortField: any, sortType: any, rowData: any) => dispatch(setLoansSort({sortField, sortType, rowData, requestId}))}
            sortField={loans.loansSortField}
            sortType={loans.loansSort}
            loading={loans.loansLoading}
            selectControlProps={
                hiddenFilterOptions
                ? undefined
                : {
                    label: "Tipo contrato",
                    autocalculateFieldName: "TipoContrato"
                }
            }
            rangeControlProps={{
                startDate: startDate,
                endDate: endDate,
                setEndDate: setEndDate,
                setStartDate: setStartDate,
            }}
            cardComponent={{
                className:  (row) => row.Estado === 'Aprobado' && row.MontoOtorgado === row.MontoAmortizado
                                        ? 'coupon-appoved-completed'
                                        : row.Estado === 'Aprobado'
                                        ? 'coupon-appoved'
                                        : row.Estado === 'Rechazado'
                                            ? 'coupon-rejected'
                                            : 'coupon-pending',
                cardContent: (row) => {
                    return (
                        <CardContent 
                            style={{padding: "0 1rem 1rem 1rem"}} 
                        >
                            <Grid container direction="row" alignItems="center" justifyContent="space-between">
                                <Grid item xs>
                                    <Typography variant="subtitle2" color="text.primary" fontWeight="bold">
                                        Préstamo N°:{" "} {row.CodPrestamoPersonal}
                                    </Typography>
                                    {/* <Typography variant="subtitle2" color="text.primary" fontWeight="bold">
                                        N°:{" "} {row.NroPrestamoPersonal}
                                    </Typography> */}
                                </Grid>
                                <Grid item maxWidth="4rem" minWidth="2rem">
                                    <LoanOptions row={row} />
                                </Grid>
                            </Grid>
                            {row.Empresa && <Grid item xs>
                                <Typography variant="subtitle2" color="text.primary" fontSize="12px">
                                    {row.Empresa}
                                </Typography>
                            </Grid>}

                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Tipo: {" "}
                                <Typography variant="body2" component="span">
                                    {row.TipoPrestamo}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Estado: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Estado} {row.Estado === 'Registrado' ? '(En el ERP)' : ''}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Moneda: {" "}
                                <Typography variant="body2" component="span">
                                    {row.DescripcionMoneda}
                                </Typography>
                            </Typography>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Fecha: {" "}
                                <Typography variant="body2" component="span">
                                    {getDatestring(row.Fecha, '-', false)}
                                </Typography>
                            </Typography>

                            <table 
                                id="table-information"
                                style={{
                                    width: "100%", 
                                    borderSpacing: "0px 0rem",
                                    borderRadius: "0.5rem",
                                }}
                            >
                                
                                <tbody>
                                {[
                                    (['Por Aprobar', 'Registrado'].includes(row.Estado) && Number(row.MontoOtorgado) === 0
                                        ? {name: "Solicitado", value: row.MontoSolicitado}
                                        : {name: "Monto Otorgado", value: row.MontoOtorgado}
                                    ),
                                    {name: "Amortizado", value: row.MontoAmortizado}, 
                                    {name: "Saldo", value: row.MontoSaldo}, 
                                ].map((row, i) => (
                                    <tr key={i} >
                                        <td>
                                        <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                            {row.name}
                                        </Typography>
                                        </td>
                                        <td style={{textAlign: 'end'}}>
                                        <Typography variant="body2" component="span">
                                            {Number(row.value).toFixed(2)}
                                        </Typography>
                                        </td>
                                </tr>))}
                                </tbody>
                            </table>
                            <Typography variant="body1" style={{marginTop: ".2rem"}}>
                                Observaciones: {" "}
                                <Typography variant="body2" component="span">
                                    {row.Observaciones}
                                </Typography>
                            </Typography>
                        </CardContent>
                    );
                },
                numberOfCards: props?.numberOfCards,
                changeViewOptionHidden: props?.changeViewOptionHidden,
            }}
            tableOptionsBar={{
                useDrawer: true,
            }}
            hiddenBottomPaginator={props?.hiddenBottomPaginator}
        />
        <Dialog
            open={loanToObservate !== undefined}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
        >
            <DialogTitle
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Detalle de pagos
            </DialogTitle>
            <DialogContent style={{width: "100%"}}>
                <Box display="flex" marginBottom=".5rem">
                    <Typography variant="subtitle2" color="text.primary" fontWeight="bold">
                        Monto Otorgado:{" "}
                    </Typography>
                    <Typography variant="body2" color="text.primary" ml={1}>
                        {loanToObservate?.MontoOtorgado}
                    </Typography>
                </Box>
                <Box display="flex" marginBottom=".5rem">
                    <Typography variant="subtitle2" color="text.primary" fontWeight="bold">
                        Monto Amortizado:{" "}
                    </Typography>
                    <Typography variant="body2" color="text.primary" ml={1}>
                        {loanToObservate?.MontoAmortizado}
                    </Typography>
                </Box>
                <Grid container direction="column" style={{marginTop: "1.5rem", width: "100%"}}>




                {paymentDetails.map((item, index) => (
                    <Grid item xs={12} key={index} mb='1rem'>
                        <Card 
                            // variant="outlined" 
                            sx={{ 
                                p: 2, 
                                position: 'relative',
                            }}
                            
                            elevation={4}
                        >
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ mb: 1.5, display: 'flex', justifyContent: 'space-between' }}>
                                    <span><strong>Cuota {item.NumeroCuota}:</strong> {item.DescripcionPeriodo}</span>
                                    {/* <Chip
                                        label={
                                            item.Estado === 1 ? 'Aprobado' :
                                            item.Estado === 2 ? 'Rechazado' :
                                            'Pendiente'
                                        }
                                        size="small"
                                        sx={{
                                            backgroundColor: item.Estado === 1 ? '#A5D6A7' :
                                                            item.Estado === 2 ? '#FFCDD2' :
                                                            '#FFF9C4',
                                            color: 'rgba(0, 0, 0, 0.87)'
                                        }}
                                    /> */}
                                </Typography>
                                {/* <Typography variant="subtitle1" sx={{ mb: 1.5, display: 'flex', justifyContent: 'space-between' }}>
                                    <span><strong>Estado:</strong> {item.Estado}</span>
                                </Typography> */}

                                <Grid container spacing={2}>
                                    {/* <Grid item xs={12} sm={6}>
                                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold' }}>Montos Otorgados</Typography>
                                        
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                            <Typography variant="body2">Cuota Normal:</Typography>
                                            <Typography variant="body2">{item.MontoOtorgado.toFixed(2)}</Typography>
                                        </Box>
                                        
                                        {item.MontoOtorgadoDoble > 0 && (
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                            <Typography variant="body2">Cuota Doble:</Typography>
                                            <Typography variant="body2">{item.MontoOtorgadoDoble.toFixed(2)}</Typography>
                                            </Box>
                                        )}
                                        
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                            <Typography variant="body2">Total Otorgado:</Typography>
                                            <Typography variant="body2" fontWeight="bold">
                                            {(item.MontoOtorgado + item.MontoOtorgadoDoble).toFixed(2)}
                                            </Typography>
                                        </Box>
                                    </Grid> */}

                                    <Grid item xs={12}>
                                    <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold' }}>Montos Amortizados</Typography>
                                    
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                        <Typography variant="body2">Cuota Normal:</Typography>
                                        <Typography variant="body2">{item.MontoAmortizado?.toFixed(2)}</Typography>
                                    </Box>
                                    
                                    {item.MontoAmortizadoDoble > 0 && (
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                        <Typography variant="body2">Cuota Doble:</Typography>
                                        <Typography variant="body2">{item.MontoAmortizadoDoble?.toFixed(2)}</Typography>
                                        </Box>
                                    )}
                                    
                                    {item.MontoAmortizadoExtraordinaria > 0 && (
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                        <Typography variant="body2">Extraordinario:</Typography>
                                        <Typography variant="body2">{item.MontoAmortizadoExtraordinaria?.toFixed(2)}</Typography>
                                        </Box>
                                    )}
                                    
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                        <Typography variant="body2">Total Amortizado:</Typography>
                                        <Typography variant="body2" fontWeight="bold">
                                        {(item.MontoAmortizado + item.MontoAmortizadoDoble + item.MontoAmortizadoExtraordinaria)?.toFixed(2)}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                        <Typography variant="body2">Saldo:</Typography>
                                        <Typography variant="body2">{item.MontoSaldo?.toFixed(2)}</Typography>
                                    </Box>
                                    </Grid>
                                </Grid>

                                {/* <Box sx={{ mt: 2, pt: 1, borderTop: '1px solid #eee', fontSize: '0.75rem', color: 'text.secondary' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span>Creado: {new Date(item.CreacionFecha).toLocaleDateString()} por {item.CreacionUsuario}</span>
                                    <span>Actualizado: {new Date(item.ActualizacionFecha).toLocaleDateString()} por {item.ActualizacionUsuario}</span>
                                    </Box>
                                </Box> */}
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={12} textAlign={"right"}>
                        <Button 
                            variant="contained" 
                            style={{width: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            onClick={async () => setLoanToObservate(undefined)}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
        <Dialog
            open={loanToCancel !== null}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
        >
            <DialogTitle
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Cancelar solicitud
            </DialogTitle>
            <DialogContent style={{width: "100%"}}>
                <Grid container direction="column" style={{marginTop: "1.5rem", width: "100%"}}>
                    <Grid item>
                        <label 
                            style={{
                                color: "#666",
                                fontFamily: "Roboto",
                                fontSize: ".875rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                            }}
                        >
                            ¿Está seguro de cancelar el préstamo seleccionado?
                        </label>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"} spacing={2}>
                    <Grid item xs={6}>
                        <Button
                            variant="outlined" 
                            style={{width: "8rem"}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            disabled={loading}
                            onClick={() => {
                                if (loading) return;
                                setLoanToCancel(null);
                            }}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                    <Grid item xs={6} textAlign={"right"}>
                        <Button
                            variant="contained" 
                            style={{width: "8rem"}}
                            startIcon={<CheckIcon style={{height: "1rem"}} />}
                            disabled={loading}
                            onClick={async () => {
                                if (loading) return;
                                setLoading(true)
                                await setEmployeeLoanCancel(loanToCancel.NroPrestamoPersonal);
                            }}
                        >
                            Aceptar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
        {couponForFileViewing !== null && <Dialog
            key={couponForFileViewing.NroPrestamoPersonal}
            maxWidth="md"
            
            open={couponForFileViewing !== null}
            aria-labelledby="responsive-dialog-title"
            style={{width: "100%"}}
            PaperProps={{
                style: {
                width: '80%',
                // maxWidth: '600px',   // Máximo ancho del Dialog
                }
            }}
            fullWidth
        
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Documentos
            </DialogTitle>
            <DialogContent style={{width: "100%", textAlign: "center"}}>
                <DocumentsComponent
                    groupId={couponForFileViewing.NroPrestamoPersonal} 
                    allowToDeleteFiles={couponForFileViewing.Estado === "Por Aprobar" && Number(couponForFileViewing.MontoOtorgado)  === 0}
                    allowToAddFiles={couponForFileViewing.Estado === "Por Aprobar" && Number(couponForFileViewing.MontoOtorgado)  === 0}
                    afterDeleteFileAction={async (files, remainingFiles) => {
                        await setEmployeeLoanHasNote(
                            couponForFileViewing.NroPrestamoPersonal, 
                            (remainingFiles - 1) > 0 ? 1 : 0,
                        );
                    }}
                    afterUploadFileAction={async (files, remainingFiles) => {
                        await setEmployeeLoanHasNote(
                            couponForFileViewing.NroPrestamoPersonal, 
                            (files.length + remainingFiles) > 0 ? 1 : 0,
                        );
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Grid container margin={"0.5rem 1.5rem 2rem 1.5rem"}>
                    <Grid item xs={12} textAlign={"right"}>
                        <Button 
                            variant="outlined" 
                            style={{width: "8rem", margin: ".5rem",}}
                            startIcon={<CloseIcon style={{height: "1rem"}} />}
                            onClick={() => setCouponForFileViewing(null)}
                        >
                            Cerrar
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>}
        {!!observationResult && <MySnackbar 
            msg={observationResult?.msg || ""}
            onClose={() => setObservationResult(null)}
            severity={observationResult?.success ? "success" : "error"}
            open={!!observationResult}
        />}
        {loanCancelResult !== null && <MySnackbar 
            msg={loanCancelResult?.msg || ""}
            onClose={() => setLoanCancelResult(null)}
            severity={loanCancelResult?.success ? "success" : "error"}
            open={loanCancelResult !== null}
        />}
        </>
    )
}

export default TableLoans;